import { alias, custom, deserialize, serializable, SKIP } from 'serializr';
import { ApplicationVersion } from './application-version.model';
import { Application } from './application.model';
import { Base } from './base.model';
import { Deserializable } from './deserializable';
import { Project } from './project.model';
import { immerable } from 'immer';
export class ProjectPreference extends Base implements Deserializable {
  static [immerable] = true;

  @serializable(
    alias(
      'project',
      custom(
        () => SKIP,
        (v) => {
          if (v != 'undefined') return v;
        },
      ),
    ),
  )
  public projectId: number;
  @serializable(
    alias(
      'version',
      custom(
        () => SKIP,
        (v) => {
          if (v != 'undefined') return v;
        },
      ),
    ),
  )
  public versionId: number;
  @serializable(
    alias(
      'application',
      custom(
        () => SKIP,
        (v) => {
          if (v != 'undefined') return v;
        },
      ),
    ),
  )
  public applicationId: number;

  @serializable(
    alias(
      'application',
      custom(
        (v) => v,
        () => SKIP,
      ),
    ),
  )
  get selectedApplicationId(): string {
    return this.selectedApplication
      ? this.selectedApplication?.id?.toString()
      : this.applicationId?.toString();
  }

  @serializable(
    alias(
      'project',
      custom(
        (v) => v,
        () => SKIP,
      ),
    ),
  )
  get selectedProjectId(): string {
    return this.selectedProject
      ? this.selectedProject?.id?.toString()
      : this.projectId?.toString();
  }

  @serializable(
    alias(
      'version',
      custom(
        (v) => v,
        () => SKIP,
      ),
    ),
  )
  get selectedVersionId(): string {
    return this.selectedVersion
      ? this.selectedVersion?.id?.toString()
      : this.versionId?.toString();
  }

  //presention serilizable data start //
  @serializable(
    custom(
      () => SKIP,
      (v) => v,
    ),
  )
  public selectedApplication: Application;
  @serializable(
    custom(
      () => SKIP,
      (v) => v,
    ),
  )
  public selectedVersion: ApplicationVersion;
  @serializable(
    custom(
      () => SKIP,
      (v) => v,
    ),
  )
  public selectedProject: Project;

  //presention serilizable data end //

  deserialize(input: any): this {
    return Object.assign(this, deserialize(ProjectPreference, input));
  }
}
